import React from 'react';
import { uuid } from 'uuidv4';

import "../App.css";

import GameGalleryItem from '../components/GameGalleryItem';

const GamesGallery = React.memo(({ gameList, setCurrentGameIndex }) =>
{
	return (

		<React.Fragment>

			{gameList.map((data, index) => (

				<GameGalleryItem
					key={uuid()}
					data={data}
					index={index}
					setCurrentGameIndex={setCurrentGameIndex}
				/>

			))}

		</React.Fragment>

	);

});

class GamesPage extends React.Component
{
	state = {
		currentIndex: 0
	};
	
	setCurrentGameIndex = (index) =>
	{
		this.setState({
			currentIndex: index
		})
	}
	
	renderScreenshots = (game) =>
	{
		var divs = [];
		
		for (var i = 0; i < game.gameScreenshots.length; i++)
		{
			divs.push(
				<div
					key={uuid()}
					className='game-details-screenshot-container'
				>
					<img
						className='game-details-screenshot'
						src={require("../images/game_art/" + game.gamePath + "/" + game.gameScreenshots[i])}
					/>
				</div>
			)
		}

		return divs;
	}

	render()
	{
		var gameList = this.props.gameList;
		var game = gameList[this.state.currentIndex];
		
		return (

			<div className='page games-page'>

				<div className='section games-gallery-section'>

					<GamesGallery
						gameList={gameList}
						setCurrentGameIndex={this.setCurrentGameIndex}
					/>

				</div>

				<div className='section game-details-section'>

					<div className='game-details-media'>

						<div className='game-details-video-container'>

							<iframe
								className='game-details-video'
								src={game.gameVideoURL}
								frameBorder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
							>

							</iframe>

						</div>

						<div className='game-details-screenshots'>
							{this.renderScreenshots(game)}
						</div>

					</div>

					<div className='game-details-info'>

						<div className='game-details-name'>
							{game.gameName}
						</div>

						<div
							className='game-details-link-container'
						>

							<a
								className='game-details-link'
								href={game.gameLink}
								target='_blank'>
								PLAY >>
							</a>

						</div>

						<div className='game-details-description'>
							{game.gameDescription}
						</div>

					</div>
					
				</div>

			</div>

		);
	}
}

export default GamesPage;